import React, { useContext, useEffect, useState } from "react";
import { View, ActivityIndicator } from "react-native";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PublicPagesApi } from "@/findifyv2-api-ts/public/pages/PagesApi";
import { FindifyPageEditorRenderNative, PageSection } from "./components/FindifyPageEditorRenderNative";
import { PlaceColors } from "./helpers/PlaceColors";

type FindifyCMSPageProps = {
    pageId: number | string;
    navigation: any;
};

export const FindifyCMSPage = ({ pageId, navigation }: FindifyCMSPageProps) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [sections, setSections] = useState<PageSection[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!findifyDataContext?.workspace) return;

        const domain = findifyDataContext.workspace?.primary_domain?.domain_name;
        const pagesApi = new PublicPagesApi(domain);

        pagesApi.get(pageId, null).then((pageData: any) => {
            if (pageData?.template_content) {
                try {
                    const content = JSON.parse(pageData.template_content);
                    setSections(content.sections || []);
                } catch (e) {
                    console.error("Failed to parse CMS page content", e);
                }
            }
            setLoading(false);
        }).catch((err) => {
            console.error("Failed to fetch CMS page", err);
            setLoading(false);
        });
    }, [pageId, findifyDataContext?.workspace]);

    if (loading) {
        return (
            <View style={{ padding: 20, alignItems: 'center' }}>
                <ActivityIndicator color={PlaceColors(findifyDataContext).primary.get()} />
            </View>
        );
    }

    return (
        <FindifyPageEditorRenderNative 
            sections={sections} 
            navigation={navigation} 
        />
    );
};
